import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

const list = {
	yes: [
		['Yep', '👌🏻'],
		['Yes indeed', '🙌🏻'],
		['Right', '🌟'],
		['Well done', '😎'],
		['Great', '👍🏻'],
		['Yeah', '😜'],
		['Sure', '🔥'],
		['Top!', '💃🏻'],
	],
	no: [
		['Nope', '☠️'],
		['Wrong', '🙅🏻‍'],
		['Eh, no', '😒'],
		['Nah', '🙄'],
		['Not really', '😞'],
		['Meh', '🙇🏻'],
		['Incorrect', '😿'],
		['Ouch', '🤦🏻‍'],
	],
}

const getItem = (result) => {
	const { length } = list[result]
	const number = Math.floor(Math.random() * length)

	return list[result][number]
}

class AssignmentResult extends Component {
	shouldComponentUpdate(nextProps) {
		return this.props.isRight !== nextProps.isRight
	}

	render() {
		const { isRight } = this.props
		const currentText = getItem(isRight ? 'yes' : 'no')

		return (
			<Fragment>
				<span
					className="taskresult-icon"
					role="img"
					aria-label={currentText[0]}
				>
					{currentText[1]}
				</span>
				<span className="taskresult-text text-4-type-2">{currentText[0]}</span>
			</Fragment>
		)
	}
}

AssignmentResult.propTypes = {
	isRight: PropTypes.bool.isRequired,
}

export default AssignmentResult
